import axios from 'axios';
import Endpoints from '../Endpoints';

export const createImageCategory = async ({ name, slug, description }) => {
  const { data } = await axios.post(
    Endpoints.ImageLibrary.CATEGORIES,
    { name, slug, description },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}`,
        'Content-Type': 'application/json',
      },
    }
  );
  return data;
};

// payload: { file: File, categoryId: string, title: string, tags?: string | string[] }
export const uploadImageAsset = async ({ file, categoryId, title, tags }) => {
  const form = new FormData();
  form.append('image', file);
  form.append('categoryId', categoryId);
  form.append('title', title);
  if (Array.isArray(tags)) form.append('tags', tags.join(','));
  else if (typeof tags === 'string') form.append('tags', tags);

  const { data } = await axios.post(Endpoints.ImageLibrary.ASSETS, form, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}`,
    },
  });
  return data;
};

// params: { categoryId?: string, includeInactive?: boolean, includeEmpty?: boolean }
export const getAdminCategoriesWithAssets = async (params = {}) => {
  const search = new URLSearchParams();
  if (params.categoryId) search.set('categoryId', params.categoryId);
  if (typeof params.includeInactive === 'boolean') search.set('includeInactive', String(params.includeInactive));
  if (typeof params.includeEmpty === 'boolean') search.set('includeEmpty', String(params.includeEmpty));

  const url = `${Endpoints.ImageLibrary.ADMIN_CATEGORIES_WITH_ASSETS}${search.toString() ? `?${search.toString()}` : ''}`;
  const { data } = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}`,
    },
  });
  return data?.data ?? [];
};

// Delete an asset by id
export const deleteImageAsset = async (assetId) => {
  const { data } = await axios.delete(`${Endpoints.ImageLibrary.ASSETS}/${assetId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }
  })
  return data
}

// Delete a category by id. Pass cascade=true to delete assets under it.
export const deleteImageCategory = async (categoryId, { cascade = false } = {}) => {
  const url = `${Endpoints.ImageLibrary.CATEGORIES}/${categoryId}${cascade ? '?cascade=true' : ''}`
  const { data } = await axios.delete(url, {
    headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }
  })
  return data
}
